import { useState } from 'react';

import { getCountryKeys } from 'modules/archive';
import { useAuthorization } from 'modules/auth';
import { getCurrentProject, getCurrentUser } from 'modules/data';
import { useI18n } from 'modules/i18n';
import { ErrorBoundary } from 'modules/react-toolbox';
import { usePathBase } from 'modules/routes';
import { FaDownload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import Select from 'react-select';

import AdminSubTab from './AdminSubTab';

export default function AdminTabPanel() {
    const { t, locale } = useI18n();
    const { isAuthorized } = useAuthorization();
    const pathBase = usePathBase();
    const user = useSelector(getCurrentUser);
    const project = useSelector(getCurrentProject);
    const countryKeys = useSelector(getCountryKeys);

    const [selectedCountries, setSelectedCountries] = useState([]);

    function countryKeyOptions() {
        return (countryKeys[locale] || []).map((x) => ({
            label: t(`countries.${x}`),
            value: x,
        }));
    }

    function userStatisticsPath() {
        let path = `${pathBase}/admin/user_statistics.csv`;
        if (selectedCountries.length > 0) {
            path = path + '?countries[]=';
            path = path + selectedCountries.join('&countries[]=');
        }
        return path;
    }

    function onCountrySelectorChange(value) {
        const array = (value || []).map((item) => item.value);
        setSelectedCountries(array);
    }

    if (!isAuthorized({ type: 'General' }, 'edit')) {
        return null;
    }

    return (
        <ErrorBoundary small>
            <h3 className="SidebarTabs-title">{t('edit.administration')}</h3>
            <div className="flyout-sub-tabs-container flyout-video">
                {project?.is_umbrella && user?.admin && (
                    <AdminSubTab
                        title="edit.instance.title"
                        url={`${pathBase}/admin/instance`}
                        obj={{ type: 'InstanceSetting' }}
                        action="update"
                    />
                )}
                <AdminSubTab
                    title="edit.users.admin"
                    url={`${pathBase}/users`}
                    obj={{ type: 'User' }}
                    action="update"
                >
                    <div>
                        <div>
                            <a href={userStatisticsPath()}>
                                <FaDownload
                                    className="Icon Icon--primary"
                                    title={t('download_user_statistics')}
                                />{' '}
                                {t('download_user_statistics')}
                            </a>
                        </div>
                        <Select
                            options={countryKeyOptions()}
                            className="basic-multi-select"
                            isMulti
                            onChange={onCountrySelectorChange}
                            styles={{
                                placeholder: (provided) => ({
                                    ...provided,
                                    cursor: 'text',
                                }),
                            }}
                            placeholder={t('filter_by_countries')}
                        />
                        {project?.has_newsletter && (
                            <div>
                                <a
                                    href={`${pathBase}/users/newsletter_recipients.csv`}
                                >
                                    <FaDownload
                                        className="Icon Icon--primary"
                                        title={t(
                                            'download_newsletter_recipients'
                                        )}
                                    />{' '}
                                    {t('download_newsletter_recipients')}
                                </a>
                            </div>
                        )}
                    </div>
                </AdminSubTab>
                <AdminSubTab
                    title="edit.statistics.title"
                    url={`${pathBase}/admin/statistics`}
                    obj={{ type: 'General' }}
                    action="edit"
                />
            </div>
        </ErrorBoundary>
    );
}
